<template>
  <div class="video">
    <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onBack">
      <template #right>
        <van-icon name="search" size="18" @click="onSearch"/>
      </template>
    </van-nav-bar>
    <van-swipe class="jz-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item         
        v-for="(item,index) in foucs"
        :key="index"
        @click="goSwipe(index)"
      >
      <img v-lazy="item.cover" class="swipe-img"/>
      </van-swipe-item>
    </van-swipe>
    <van-tabs @click="getAlbum()" v-model="cid">
      <van-tab 
      v-for="(item,index) in clist" 
      :key="index"
      :title="item.title"
      :name="item.id"
      >
      <ul class="t-list">
          <li
          v-for="(item, index) in alist" 
          :key="index"
          class="t-item"
          >
            <a @click="goto(`${item.id}`)">
            <div class="t-item-title">{{ item.title }}</div>
            <div class="t-item-desc">
              <div class="van-multi-ellipsis--l2">
                {{ item.description }}
              </div>
              <div class="t-item-date">{{ item.date }} | {{ item.author }}</div>
            </div>
          </a>
        </li>
        </ul>
      </van-tab>
    </van-tabs>
  </div>

</template>
<script>

export default {
  name: 'Master',
  data() {
    return {
      title: '學院導師',
      clist: [],
      alist: [],
      foucs: [],
      cid: 0,
      activeId: 0,
      page:0,
      last_page:1,
      metaTitle: '',
    }
  },
  methods: {
    //获取欄目列表
    getCategory(id){
      this.axios.get(this.$tools.api + '/pureland/getmaster')
      .then(response => {
        if(response.data.code==1){
          this.clist = response.data.rows;
          if(id==null){
            this.cid = this.clist[0].id;
          }else{
            this.cid = id;
          }
          this.getAlbum();
          this.getFocus();
        }
      }) 
    },
    //获取專輯列表
    getAlbum(){
      if(this.cid != this.activeId){
        this.page = 0;
        this.last_page =1;
        this.$router.push({ path: `/master/${this.cid}` }) // -> /user/123
      }
      if(this.page < this.last_page){
        this.page ++;
        let url = this.$tools.api + '/book/getlist?cid='+this.cid+'&page=' + this.page;
        if(this.cid != this.activeId){
          this.alist = [];
          this.activeId = this.cid;
        }
        this.axios.get(url)
        .then(response => {
            let lis = response.data.rows.data;
            for (let i = 0; i < lis.length; i++) {
                this.alist.push(lis[i]); 
            }            
            if(this.page==1){
              this.last_page = response.data.rows.last_page;   
            } 
        }) 
      }
      this.metaTitle = this.$tools.getCategoryTitle(this.clist, this.cid);
    },
    getFocus(){
      this.axios.get(this.$tools.api + '/pureland/getmasterfocus')
      .then(response => {
        if(response.data.code==1){
          this.foucs = response.data.rows;
        }
      }) 
    },
    goSwipe(index) {
      this.index = index;
      this.goto(this.foucs[index].id);
    },   
    //返回
    onBack(){
      this.$router.push({ path: `/` }) // -> /user/123
    },
    goto(id){
      this.$router.push({ path: `/view/b/${id}` }) // -> /user/123
    },   
    // 滚动操作
    handleScroll() {
      var scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop; //变量windowHeight是可视区的高度
      var windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight; //变量scrollHeight是滚动条的总高度
      var scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + windowHeight == scrollHeight) {
          this.getAlbum();
          return false;
      }
    },
    onSearch(){
      this.$router.push({ path: `/search/master` }) // -> /user/123
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll",this.handleScroll,true)
  },
  mounted(){
    // 监听滚动
    window.addEventListener('scroll',this.handleScroll,true)
  },
  created() {
    this.getCategory(this.$route.params.id);
  },
  metaInfo () {
    return {
      title: this.metaTitle + '-' + this.title
    }
  },
};
</script>
<style  scoped>
.model{
  text-align: center;
  height:35px;
  line-height: 35px;
  background-color: #f7f8fa;
}
.is-model{
  color: #fff;
  background-color: #39a9ed;
}
.t-list{
  margin:20px 20px 50px 20px;
}
.t-item{
  border-bottom: solid 1px #f7f8fa;
}
.t-item-title{
  font: 12px/1.14 PingFang SC,Hiragino Sans GB,Microsoft YaHei,WenQuanYi Micro Hei,Helvetica Neue,Arial,sans-serif;
  font-size:15px;
  line-height: 40px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.t-item-desc{
  font-size: 10px;
  line-height: 20px;
  margin-bottom: 10px;
  color: #707070;
}
.t-item-date{
  padding:5px 0px;
}
.swipe-img{
  width:100%;
  height:230px;
  object-fit: cover;
}
</style>